import httpService from "./httpService";

class ChatService {
  // a picture copied into the chat box with text, fetched by the server ({ Good, type, data: base64 })
  async getCopiedImage(url) {
    return await httpService.get(`/chat/copied-image?url=${encodeURIComponent(url)}`);
  }

  // rename a channel (its owner or a Company Admin): { roomId, name }
  async renameRoom(payload) {
    return await httpService.post("/chat/rename-room", payload);
  }

  async getRooms() {
    return await httpService.get("/chat/rooms");
  }

  async searchUsers(query) {
    return await httpService.get(`/chat/search-users?query=${query}`);
  }

  async getMentionUsers(companyId) {
    return await httpService.get(`/user/note-mentions?company_id=${companyId}`);
  }

  async getOrCreateRoom(payload) {
    return await httpService.post("/chat/get-or-create-room", payload);
  }

  async getMessages(roomId, page = 1, after = null) {
    const qs = after
      ? `page=${page}&after=${encodeURIComponent(after)}`
      : `page=${page}`;
    return await httpService.get(`/chat/messages/${roomId}?${qs}`);
  }

  async sendMessage(payload) {
    // payload can be FormData if it contains attachments
    const config = payload instanceof FormData 
      ? { headers: { "Content-Type": "multipart/form-data" } }
      : {};
    return await httpService.post("/chat/send-message", payload, config);
  }

  async toggleReaction(payload) {
    return await httpService.post("/chat/reaction", payload);
  }

  async addMember(payload) {
    return await httpService.post("/chat/add-member", payload);
  }

  async leaveRoom(payload) {
    return await httpService.post("/chat/leave-room", payload);
  }

  async removeMember(payload) {
    return await httpService.post("/chat/remove-member", payload);
  }

  async deleteRoom(payload) {
    return await httpService.post("/chat/delete-room", payload);
  }

  async clearMessages(payload) {
    return await httpService.post("/chat/clear-messages", payload);
  }

  async togglePin(payload) {
    return await httpService.post("/chat/toggle-pin", payload);
  }

  async getPinnedMessages(roomId) {
    return await httpService.get(`/chat/pins/${roomId}`);
  }

  async editMessage(payload) {
    const config = payload instanceof FormData
      ? { headers: { "Content-Type": "multipart/form-data" } }
      : {};
    return await httpService.post("/chat/edit-message", payload, config);
  }

  async deleteMessage(payload) {
    return await httpService.post("/chat/delete-message", payload);
  }

  async getPostTypes(roomId) {
    return await httpService.get(`/chat/post-types/${roomId}`);
  }

  async savePostType(payload) {
    return await httpService.post("/chat/post-types", payload);
  }

  async deletePostType(payload) {
    return await httpService.post("/chat/post-types/delete", payload);
  }

  async sendInvite(payload) {
    return await httpService.post("/chat/invite", payload);
  }

  async generateInviteLink(payload) {
    return await httpService.post("/chat/generate-link", payload);
  }

  async acceptInvite(token) {
    return await httpService.get(`/chat/accept-invite/${token}`);
  }

  async updatePermission(payload) {
    return await httpService.post("/chat/update-permission", payload);
  }

  async getRoomPermissions(roomId) {
    return await httpService.get(`/chat/room-permissions/${roomId}`);
  }

  async markAsRead(roomId) {
    return await httpService.post("/chat/mark-read", { roomId });
  }

  async hideRoom(roomId) {
    return await httpService.post("/chat/hide-room", { roomId });
  }

  async unhideRoom(roomId) {
    return await httpService.post("/chat/unhide-room", { roomId });
  }

  async muteRoom(roomId) {
    return await httpService.post("/chat/mute-room", { roomId });
  }

  async markAsUnread(roomId) {
    return await httpService.post("/chat/mark-unread", { roomId });
  }
}

const chatServiceInstance = new ChatService();
export default chatServiceInstance;
